import { useMemo } from 'react'
import { format_address } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.map(d => ({
      id: d._id,
      text: format_address(d.postal_address),
    }))
  }, [data])
}
